import type { ReactNode } from 'react';
import { Link } from 'react-router';
import AuthBrand from './AuthBrand';

type AuthCenteredLayoutProps = {
  title: string;
  description: string;
  children: ReactNode;
};

/** La scheda centrata delle schermate di recupero: marchio, titolo, contenuto e ritorno al login. */
export default function AuthCenteredLayout({
  title,
  description,
  children,
}: AuthCenteredLayoutProps) {
  return (
    <main className="flex min-h-screen flex-col items-center justify-center bg-canvas px-4 py-10">
      <div className="w-full max-w-md rounded-hero border border-default bg-default p-6 shadow-resting sm:p-8">
        <AuthBrand className="mb-8" />
        <h1 className="text-hero-title text-strong">{title}</h1>
        <p className="mt-2 text-body text-muted md:text-body-lg">{description}</p>
        {children}
        <p className="mt-8 text-center text-sm">
          <Link
            to="/login"
            className="rounded-xs font-medium text-link hover:underline focus-visible:focus-ring"
          >
            Torna al login
          </Link>
        </p>
      </div>
    </main>
  );
}
